import { render, staticRenderFns } from "./LargeFacePills.vue?vue&type=template&id=6f087ce2&"
import script from "./LargeFacePills.vue?vue&type=script&lang=js&"
export * from "./LargeFacePills.vue?vue&type=script&lang=js&"
import style0 from "./LargeFacePills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports